<template>
  <div :class="name">    
    <div class="trigger">
      <div v-if="!isMobileSize" class="in">
        <div v-if="!submitOnly" class="item">
          <BaseButton
            class="button--weak"
            :class="{ 'button-favorites': name === 'favorites' }"
            type="button"
            @click.native="$emit('close')"
            :disabled="disableOnSubmit"
          >
            {{ cancelButton }}
          </BaseButton>
        </div>

        <div v-if="canSubmit" class="item">
          <BaseButton
            type="button"
            :class="[submitClass, { 'button-favorites': name === 'favorites' }]"
            @click.native="$emit('on-submit')"
            :disabled="disableOnSubmit"
            :show-icon="showSubmitButtonIcon"
          >
            {{ submitButton }}
          </BaseButton>
        </div>
      </div>

      <div v-else class="in">
        <div v-if="canSubmit" class="item">
          <BaseButton
            type="button"
            :class="[submitClass, { 'button-favorites': name === 'favorites' }]"
            @click.native="$emit('on-submit')"
            :disabled="disableOnSubmit"
            :show-icon="showSubmitButtonIcon"
          >
            {{ submitButton }}
          </BaseButton>
        </div>

        <div v-if="!submitOnly" class="item">
          <BaseButton
            class="button--weak"
            :class="{ 'button-favorites': name === 'favorites' }"
            type="button"
            @click.native="$emit('close')"
            :disabled="disableOnSubmit"
          >
            {{ cancelButton }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BaseButton from '@/components/Templates/BaseButton';

export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    canSubmit: {
      type: Boolean,
      default: false
    },
    disableOnSubmit: {
      type: Boolean,
      default: false
    },
    showSubmitButtonIcon: {
      type: Boolean,
      default: true
    },
    submitOnly: {
      type: Boolean,
      default: false
    },
    submitLabel: {
      type: String,
      default: null
    },
    cancelLabel: {
      type: String,
      default: null
    },
    submitClass: {
      type: [String, Object],
      default: null
    }
  },
  components: { BaseButton },
  computed: {
    ...mapState('layout', ['isMobileSize']),
    cancelButton() {
      return this.cancelLabel || this.$t('mbti.modal.button.close');
    },
    submitButton() {
      return this.submitLabel || this.$t('mbti.modal.button.submit');
    }
  }
};
</script>

<style lang="scss" scoped src="@/assets/scss/modal_footer.scss" />
